import { Module, VuexModule, Mutation } from "vuex-module-decorators";

@Module({
  namespaced: true,
  name: "UserManagement"
})
export default class UserManagement extends VuexModule {
  searchQuery = "";

  @Mutation
  updateSearchQuery(val: UserManagement["searchQuery"]) {
    this.searchQuery = val;
  }
}
